export default "__VITE_ASSET__JUQeHy9G__"